module.exports = __webpack_public_path__ + "media/images/nectar-9d4581c06015f4ccea30f8ef2ad439c2.png";